import React from "react";
import { Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import CustomAppBar from "../components/CustomAppBar";
import ContinueButton from "./ContinueButton";
import { continueButtonSx } from "../lib/uiformatting";
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";

export default function Message(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                backgroundColor: theme.palette.background.default,
            }}
        >
            {!props.noAppBar && (
                <CustomAppBar
                    noBack={props.noBack}
                    returning={props.returning}
                    main={props.main}
                    onBack={props.onBack}
                />
            )}

            <Box
                sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    px: { xs: "2rem", sm: "5rem", md: "10rem" },
                    pt: "clamp(1rem, 5vh, 6rem)",
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        maxWidth: isDesktop ? "600px" : "100%",
                        margin: "0 auto",
                        mb: "clamp(1rem, 3vh, 3rem)",
                        textAlign: isDesktop ? "center" : "left",
                    }}
                >
                    {props.title && (
                        <Typography
                            variant="h5"
                            sx={{
                                fontFamily: "Sentient",
                                color: "#151515",
                                fontSize: "clamp(14px, 3vh, 28px)",
                                fontWeight: 400,
                                mt: "clamp(0.5rem, 1.5vh, 1.5rem)",
                                mb: "clamp(0.5rem, 1.5vh, 1.5rem)",
                            }}
                        >
                            {props.title}
                        </Typography>
                    )}

                    {props.subtitle && (
                        <Typography
                            variant="body1"
                            sx={{
                                mb: "clamp(0.5rem, 1.5vh, 1.5rem)",
                                fontSize: "clamp(12px, 2.5vh, 24px)",
                            }}
                        >
                            {props.subtitle}
                        </Typography>
                    )}
                </Box>
            </Box>

            {props.next && (
                <Box
                    sx={{
                        ...continueButtonSx,
                        position: "sticky",
                        bottom: 0,
                    }}
                >
                    <ContinueButton
                        onClick={() => setPageAndDeferNavigate(dispatch, props.next, navigate)}
                        title={props.nextTitle ? props.nextTitle : "Continue"}
                        disabled={!props.selected}
                        selected={props.selected}
                    />
                </Box>
            )}
        </Box>
    );
}
